import React, { useEffect, useMemo, useState } from "react";
import { NavLink, Route, Routes, useLocation, useParams, Navigate, Link } from "react-router-dom";
import { SCREEN_GROUPS, findScreen, flattenScreens, countByVariant } from "./lib/screen-catalog.js";
import { useTelemetry } from "./lib/telemetry.jsx";
import { HomePage } from "./pages/Home.jsx";
import { CatalogPage } from "./pages/Catalog.jsx";

function SidebarNav() {
  return (
    <nav className="ef-side" aria-label="Pantallas EducaFinaz">
      <h1>EducaFinaz · educa1</h1>
      <NavLink to="/" end className={({ isActive }) => "ef-link" + (isActive ? " active" : "")}>
        ← Inicio
      </NavLink>
      <NavLink to="/catalogo" className={({ isActive }) => "ef-link" + (isActive ? " active" : "")}>
        Catálogo editorial (YAML)
      </NavLink>
      {SCREEN_GROUPS.map((group) => (
        <section key={group.id} className="ef-group">
          <div className="ef-group-title">{group.title}</div>
          {group.items
            .filter((it) => it.component)
            .map((it) => (
              <NavLink
                key={it.slug}
                to={`/p/${it.slug}`}
                className={({ isActive }) => "ef-link" + (isActive ? " active" : "")}
              >
                {it.label}
              </NavLink>
            ))}
        </section>
      ))}
    </nav>
  );
}

function ScreenView() {
  const { slug } = useParams();
  const screen = useMemo(() => findScreen(slug), [slug]);
  const { emit } = useTelemetry();

  useEffect(() => {
    if (screen) emit("screen_view", { slug, variant: screen.variant });
  }, [slug, screen, emit]);

  if (!screen) return <Navigate to="/" replace />;
  const Comp = screen.component;
  const isMobile = screen.variant === "cristal";

  return (
    <div>
      <div className="ef-toolbar" role="region" aria-label="Cabecera de pantalla">
        <div>
          <strong>{screen.label}</strong>
          <span style={{ color: "#6e85b3", marginLeft: 8 }}>
            · {screen.variant} · {screen.width}×{screen.height}
          </span>
        </div>
        <div className="right">
          <a
            href={`https://github.com/anthropics/educa1#${screen.slug}`}
            onClick={(e) => e.preventDefault()}
            style={{ color: "#86a3d9", textDecoration: "none", fontSize: 11 }}
          >
            ID: {screen.slug}
          </a>
          <Link to="/" className="ef-link" style={{ padding: "4px 10px" }}>
            ← volver
          </Link>
        </div>
      </div>
      <div className="ef-screen-wrap">
        <div
          className="ef-frame"
          style={{
            width: screen.width,
            maxWidth: "100%",
          }}
        >
          <div className="frame-meta">
            <span className="mono">{screen.groupTitle}</span>
          </div>
          <div
            style={{
              transformOrigin: "top left",
              transform: !isMobile && window.innerWidth < screen.width + 360
                ? `scale(${(window.innerWidth - 360) / screen.width})`
                : "none",
            }}
          >
            <Comp />
          </div>
        </div>
      </div>
    </div>
  );
}

export function App() {
  const location = useLocation();
  const { emit } = useTelemetry();
  const counts = useMemo(() => countByVariant(), []);

  useEffect(() => {
    emit("route_change", { path: location.pathname });
  }, [location.pathname, emit]);

  return (
    <div className="ef-app">
      <SidebarNav />
      <main className="ef-main" id="main">
        <Routes>
          <Route path="/" element={<HomePage counts={counts} />} />
          <Route path="/catalogo" element={<CatalogPage />} />
          <Route path="/p/:slug" element={<ScreenView />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      <div className="ef-mock-toast">datos sintéticos · pendiente de Finaz Data</div>
    </div>
  );
}
